import React from 'react';

const AdmissionCommittee = () => {
  return (
    <div>
      AdmissionCommittee
      AdmissionCommittee
    </div>
  );
}

export default AdmissionCommittee;
